import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API service functions
export const apiService = {
  // Consultation requests
  createConsultation: async (data) => {
    const response = await api.post('/consultations', data);
    return response.data;
  },

  // Landing page leads
  createLPLead: async (data) => {
    const response = await api.post('/lp-leads', data);
    return response.data;
  },

  // Contact messages
  createContactMessage: async (data) => {
    const response = await api.post('/contact', data);
    return response.data;
  },

  // Service inquiries
  createServiceInquiry: async (data) => {
    const response = await api.post('/service-inquiry', data);
    return response.data;
  },

  // Admin endpoints (for future use)
  getConsultations: async () => {
    const response = await api.get('/consultations');
    return response.data;
  },

  getLPLeads: async () => {
    const response = await api.get('/lp-leads');
    return response.data;
  },

  getContactMessages: async () => {
    const response = await api.get('/contact');
    return response.data;
  },

  getServiceInquiries: async () => {
    const response = await api.get('/service-inquiries');
    return response.data;
  },
};

export default api;
